import { Box, Card, CardContent, FormControlLabel, Radio, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RecipientCardProps } from "../../../payment.types";

const RecipientCard = ({
  value,
  selectedValue,
  onChange,
  Icon,
  title,
  description,
  disabled,
  comingSoon,
}: RecipientCardProps) => {
  const { t } = useTranslation();
  return (
    <Card
      sx={{
        width: "calc(50% - 12px)",
        position: "relative",
        border: selectedValue === value ? "1px solid #106048" : "1px solid #EAECF0",
        padding: "16px",
        borderRadius: "12px",
        background: "#F9FBFA",
        boxShadow: "none",
        minHeight: "180px",
        cursor: disabled ? "default" : "pointer",
      }}
      onClick={!disabled ? () => onChange(value) : undefined}
    >
      <CardContent
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          rowGap: "16px",
          padding: "0 !important",
          opacity: disabled ? 0.4 : 1,
        }}
      >
        <Icon />
        <FormControlLabel
          value={value}
          sx={{ margin: 0 }}
          control={
            <Radio
              checked={selectedValue === value}
              sx={{ position: "absolute", top: "16px", right: "16px" }}
              disabled={disabled}
            />
          }
          label={
            <Box>
              <Typography
                component="h6"
                sx={{
                  color: "#1C1C1C",
                  fontSize: "18px",
                  fontWeight: 600,
                  lineHeight: "28px",
                  marginBottom: "8px",
                }}
              >
                {title}
              </Typography>
              <Typography
                component="p"
                sx={{
                  color: "#A0A0A0",
                  fontSize: "13px",
                  fontWeight: 400,
                }}
              >
                {description}
              </Typography>
            </Box>
          }
        />
      </CardContent>
      {comingSoon && (
        <Typography
          component="span"
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: 600,
            borderRadius: "8px 8px 0px 0px",
            background: "#F3BC4E",
            position: "absolute",
            left: "50%",
            bottom: "0px",
            transform: "translateX(-50%)",
            padding: "3px 12px",
            whiteSpace: "nowrap",
          }}
        >
          {t("pages.payment.createPaymentLink.comingSoon")}
        </Typography>
      )}
    </Card>
  );
};

export default RecipientCard;
